import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { initUppyAtom, cleanupUppyAtom } from '../../../../atoms/v3/uppyAtoms';

export const UppyProvider: React.FC<{ children: React.ReactNode}> = ({ children }) => {
    const [, initUppy] = useAtom(initUppyAtom);
    const [, cleanupUppy] = useAtom(cleanupUppyAtom);

    useEffect(() => {
        // 初始化Uppy实例
        initUppy();
        
        // 组件卸载时清理Uppy实例
        // return () => {
        // cleanupUppy();
        // };
    }, []);    // 仅在组件挂载时执行一次
    return children;
};
